var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBreadCrumbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.53125 1.13678L3.58458 4.19678L0.53125 7.25678L1.47125 8.19678L5.47125 4.19678L1.47125 0.196777L0.53125 1.13678Z",
    fill: "#535D6A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBreadCrumbs);
export default __webpack_public_path__ + "static/media/arrow-breadCrumbs.e71cb3c118494861d62b2d728b7cbf1d.svg";
export { ForwardRef as ReactComponent };